import AccessRightsCard from './AccessRightsCard.container';
export default AccessRightsCard;
